// Mock data for AMTEE PUBLIC SCHOOL website

export const notices = [
  {
    id: 1,
    title: "Admission Open for Session 2025-26",
    description: "Admissions are now open for all classes. Limited seats available. Visit school office for registration.",
    date: "2025-01-15"
  },
  {
    id: 2,
    title: "Annual Sports Day - February 2025",
    description: "Annual Sports Day will be held on 20th February 2025. All parents are invited to attend.",
    date: "2025-01-10"
  },
  {
    id: 3,
    title: "Parent-Teacher Meeting Scheduled",
    description: "Parent-Teacher meeting for all classes will be conducted on 25th January 2025 at 10:00 AM.",
    date: "2025-01-08"
  },
  {
    id: 4,
    title: "Winter Vacation Notice",
    description: "School will remain closed for winter vacation from 25th December 2024 to 5th January 2025.",
    date: "2024-12-20"
  },
  {
    id: 5,
    title: "Smart Bus Tracking System Launched",
    description: "Now parents can track school bus location in real-time. Download the tracking app from school office.",
    date: "2024-12-15"
  }
];

export const features = [
  {
    id: 1,
    title: "Quality Education",
    description: "Strong academic foundation with focus on overall development",
    icon: "BookOpen"
  },
  {
    id: 2,
    title: "Experienced Teachers",
    description: "Dedicated and qualified faculty guiding every student",
    icon: "Users"
  },
  {
    id: 3,
    title: "Smart Bus Tracking",
    description: "Stay updated with real-time bus arrival notifications",
    icon: "Bus"
  }
];

export const schoolInfo = {
  name: "AMTEE PUBLIC SCHOOL",
  affiliation: "U.P. Board (Affiliation No. 10844-46/2017-18)",
  address: "Malhipur Road, Near Manav Sewa Clinic, Bahraich",
  phone: "+91 9839400191",
  email: "amteepublicschool@gmail.com",
  whatsapp: "919161112008",
  whatsappLink: "https://wa.me/919161112008?text=Hello%20I%20want%20to%20inquire%20about%20admission",
  logo: "https://customer-assets.emergentagent.com/job_amtee-parent-connect/artifacts/l2xzu9es_IMG-20171228-WA0009.jpg"
};

export const menuItems = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Admission", path: "/admission" },
  { name: "Notices", path: "/notices" },
  { name: "Contact", path: "/contact" }
];
